import * as pc from 'playcanvas';

// Standard material with configurable metalness and gloss
export function createMaterial(color, metalness = 0.3, gloss = 0.7) {
    const material = new pc.StandardMaterial();
    material.diffuse = color;
    material.metalness = metalness;
    material.gloss = gloss;
    material.update();
    return material;
}

// Glowing/emissive material for effects
export function createGlowMaterial(color, intensity = 0.8) {
    const material = new pc.StandardMaterial();
    material.diffuse = color;
    material.emissive = new pc.Color(
        color?.r !== undefined ? color.r * intensity : intensity,
        color?.g !== undefined ? color.g * intensity : 0,
        color?.b !== undefined ? color.b * intensity : 0
    );
    material.metalness = 0.0;
    material.gloss = 0.9;
    material.update();
    return material;
}

// Metallic material for armor/boss
export function createMetalMaterial(color) {
    const material = new pc.StandardMaterial();
    material.diffuse = color;
    material.metalness = 0.8;
    material.gloss = 0.9;
    material.update();
    return material;
}

// Cartoon-style material (less metallic)
export function createCartoonMaterial(color) {
    return createMaterial(color, 0.2, 0.6);
}

// Transparent material for effects
export function createTransparentMaterial(color, opacity = 0.5) {
    const material = new pc.StandardMaterial();
    material.diffuse = color;
    material.opacity = opacity;
    material.blendType = pc.BLEND_NORMAL;
    material.update();
    return material;
}
